import { virtel_schema_smart_get } from "./ter-virtel-definition-lib";
import { _get_fixed_fields } from "./ter-virtel-utils";
import { _getParamsFromLib } from "./ter-params-utils";
import { js_utils } from "../utils/frfr-js-utils";
import { _datarender_virbom_from_single_virtel } from "./ter-virbom-datarender";


// TER DRAFTEL CODECS LIB

/*

*/


export const draftel_codecs_pack_terkk$materijalcustom = {};


// ---------- CODEC SCHEMA METHODS ----------


draftel_codecs_pack_terkk$materijalcustom.default_preset_state = () => {
  const preset_state = {
    _draftelschemakey: 'terkk$materijalcustom',
    terkknivo: 'CHILDOFMODUL', // ???
    // ID polje ne ide u preset, dobija se samo u EDIT MODE ali i tada mora biti obezbedjeno
    terkategorija: null,
    tergrupacustom: null,
    identcustom: null,
    naziv: null,
    kolicina: null,
    jm: "kom",
    Par28: null,
    Par29: null,

    // NOVO
    _temp_nacin_unosa: "SINGLE",
    _temp_protobomp: null,
    flag_masa_po_jm_custom: false, // NOVO 2024-04-23
    masa_po_jm_custom: null, // NOVO 2024-04-23
    flag_cena_po_jm_custom: false, // NOVO 2024-11-14
    cena_po_jm_custom: null, // NOVO 2024-11-14
  };
  return preset_state;
};


draftel_codecs_pack_terkk$materijalcustom.default_subform_item_preset_state = () => {
  const preset_state = {
    thisis: "TEMP_SUBFORM_ITEM",
    _draftelschemakey: 'terkk$materijalcustom',
    //
    terkategorija: null,
    tergrupacustom: null,
    identcustom: null,
    naziv: null,
    kolicina: null,
    jm: "kom",
    Par28: null,
    Par29: null,
    flag_masa_po_jm_custom: false, // NOVO 2024-04-23
    masa_po_jm_custom: null, // NOVO 2024-04-23
    flag_cena_po_jm_custom: false, // NOVO 2024-11-14
    cena_po_jm_custom: null, // NOVO 2024-11-14
  };
  return preset_state;
};


draftel_codecs_pack_terkk$materijalcustom.keys_for_direct_cloning = [
  "rev_id",
  "superkey",
  "subkey",
  "parent_subkey",
  ...Object.keys(draftel_codecs_pack_terkk$materijalcustom.default_preset_state())
];


// ---------- CODEC ENCODING  - DRAFTEL TO VIRBOM DIRECTION ----------


draftel_codecs_pack_terkk$materijalcustom.drafel_to_virtel = (formState) => {
  // pretvara iz formState u virtel format sa ispravnim flagovima
  const sema = virtel_schema_smart_get('terkk$materijalcustom');
  console.log(formState);
  let state = {
    ...formState
  };
  let flag_masa_po_jm_custom = false; // NOVO 2024-04-23
  let masa_po_jm_custom = null; // NOVO 2024-04-23
  if (state.flag_masa_po_jm_custom === true && state.masa_po_jm_custom > 0) {
    flag_masa_po_jm_custom = true;
    masa_po_jm_custom = state.masa_po_jm_custom;
  }
  let flag_cena_po_jm_custom = false; // NOVO 2024-04-23
  let cena_po_jm_custom = null; // NOVO 2024-04-23
  if (state.flag_cena_po_jm_custom === true && state.masa_po_jm_custom > 0) {
    flag_cena_po_jm_custom = true;
    cena_po_jm_custom = state.cena_po_jm_custom;
  }
  const state2 = {
    virtelschemakey: 'terkk$materijalcustom',
    ...state,
    flag_masa_po_jm_custom,
    masa_po_jm_custom,
    flag_paired_with_smartel: true, // ovaj virtel direktno uparen sa smartel.subkey
    ..._get_fixed_fields(sema),
    ..._getParamsFromLib("terkk$materijalcustom") // parametri na kraju imaju prioritet
  };
  if (flag_masa_po_jm_custom !== true) {
    delete state2.flag_masa_po_jm_custom;
    delete state2.masa_po_jm_custom;
  }
  if (flag_cena_po_jm_custom !== true) {
    delete state2.flag_cena_po_jm_custom;
    delete state2.cena_po_jm_custom;
  }
  return state2; // return virtel
};


draftel_codecs_pack_terkk$materijalcustom.drafel_to_virbom = (draftel) => {
  // MAIN CONVERT METHOD
  // const sema = virtel_schema_smart_get('terkk$materijalcustom');
  const virtel = draftel_codecs_pack_terkk$materijalcustom.drafel_to_virtel(draftel);
  const virbom = _datarender_virbom_from_single_virtel(virtel);
  return virbom; // return virtel
};


// ---------- CODEC DECODING - VIRBOM TO DRAFTEL DIRECTION ----------


draftel_codecs_pack_terkk$materijalcustom.virtel_to_draftel = (virtel) => {
  // pretvara iz virtela u formState format
  //
  let state = {
    ...draftel_codecs_pack_terkk$materijalcustom.default_preset_state(),
    ...js_utils.clone_obj_but_only_selected_keys(virtel, draftel_codecs_pack_terkk$materijalcustom.keys_for_direct_cloning)
  };
  //
  return state;
};

